import axios from 'axios';
import React, { useState, useCallback, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import config from '../../config/config';
import constant from '../../utils/Constant';
import Loader from '../partials/Loader';

const {
    BOOLEAN_FALSE: falseValue,
    BOOLEAN_TRUE: trueValue,
    EMPTY_STRING: emptyString,
    SITE_SETTING_END_POINT,
    UPDATE_SITE_SETTING_END_POINT,
    NULL,
    ZERO,
    STATUS_200,
    STATUS_401,
    LOGOUT,
    S3_BASE_URL
} = constant;

const SiteSetting = () => {
    const navigate = useNavigate();

    const [headerButtonText, setHeaderButtonText] = useState(emptyString);
    const [footerDescription, setFooterDescription] = useState(emptyString);
    const [copyright, setCopyright] = useState(emptyString);
    const [logo, setLogo] = useState(NULL);
    const [favicon, setFavicon] = useState(NULL);
    const [loading, setLoading] = useState(falseValue);
    const [disableButton, setDisableButton] = useState(falseValue);

    // * get token from local storage
    const token = localStorage.getItem('vendor_super_token');

    // * execute site setting request api
    const executeSiteSettingApi = useCallback(async () => {
        try {
            const apiUrl = config.appBaseUrl + SITE_SETTING_END_POINT;

            // * execute get request
            const response = await axios.get(apiUrl, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // * api response
            const result = response.data;

            // * if response is success
            if (result.code === STATUS_200 && result.status) {
                setLogo(S3_BASE_URL + result.data.logo);
                setFavicon(S3_BASE_URL + result.data.favicon);
                setHeaderButtonText(result.data.header_button_text);
                setFooterDescription(result.data.description);
                setCopyright(result.data.copyright);
            }
        } catch (error) {
            toast.error(error.response?.data?.message);

            // * if token is expired
            if (error.response?.data?.code === STATUS_401) {
                navigate(LOGOUT);
            }
        }
    }, [navigate, token]);

    // * execute site setting request api
    useEffect(() => {
        executeSiteSettingApi();
    }, [executeSiteSettingApi, token]);

    // * header button text changer
    const handleHeaderTextChange = (e) => {
        setHeaderButtonText(e.target.value);
    };

    //* footer description change
    const handleFooterDescChange = (e) => {
        setFooterDescription(e.target.value);
    };

    //* copyright text changer
    const handleCopyrightChange = (e) => {
        setCopyright(e.target.value);
    };

    // * logo change
    const handleLogoChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            if (logo) {
                URL.revokeObjectURL(logo.preview);
            }

            const previewUrl = URL.createObjectURL(file);
            file.preview = previewUrl;

            setLogo(file);
        }
    };

    // * favicon change
    const handleFaviconChange = (e) => {
        const file = e.target.files[ZERO];
        if (file) {
            if (logo) {
                URL.revokeObjectURL(logo.preview);
            }

            const previewUrl = URL.createObjectURL(file);
            file.preview = previewUrl;

            setFavicon(file);
        }
    };

    // * execute update site setting api
    const executeUpdateVendorApi = async () => {

        // * set loading and disable button
        setLoading(trueValue);
        setDisableButton(trueValue);

        // * create form data
        const logoInput = document.getElementById('logo-input');
        const faviconInput = document.getElementById('favicon-input');

        const data = new FormData();

        // if (logoInput.files.length > ZERO) {
        //     data.append('logo', logoInput.files[ZERO]);
        // } else {
        //     data.append('logo', NULL);
        // }

        // if (faviconInput.files.length > ZERO) {
        //     data.append('favicon', faviconInput.files[ZERO]);
        // } else {
        //     data.append('favicon', NULL);
        // }

        data.append('description', footerDescription);
        data.append('copyright', copyright);
        data.append('header_button_text', headerButtonText);

        try {
            const apiUrl = `${config.appBaseUrl + UPDATE_SITE_SETTING_END_POINT}`;

            // * execute put request
            const response = await axios.post(apiUrl, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // * api response
            const apiResponse = response.data;

            // * if response is success
            if (apiResponse.code === STATUS_200) {
                toast.success(apiResponse.message)
                executeSiteSettingApi();
            }
        } catch (error) {
            handleError(error);
            // * if token is expired
            if (error.response?.data?.code === STATUS_401) {
                navigate(LOGOUT);
            }
        } finally {
            setLoading(falseValue);
            setDisableButton(falseValue);
        }
    };

    //* handle error
    const handleError = (error) => {
        const errorData = error.response?.data?.data;

        if (errorData && typeof errorData === 'object') {
            const firstKey = Object.keys(errorData)[0];
            const firstMessage = errorData[firstKey][0];
            toast.error(firstMessage);
        } else {
            toast.error('Something was broken!');
        }
    };

    return (
        <>
            <ToastContainer autoClose={700} position='top-center' />
            <div className='page-content'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='page-title-box d-flex align-items-start align-items-sm-center justify-content-between gap-2'>
                                <h4 className='mb-2 mb-sm-0'>Site Setting</h4>
                                <div className='page-title-right'>
                                    <ol className='breadcrumb m-0'>
                                        <li className='breadcrumb-item'>
                                            <Link to='/dashboard'>Dashboard</Link>
                                        </li>
                                        <li className='breadcrumb-item active'>Site Setting</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-12 col-md-12 col-lg-12 col-xl-8 col-xxl-4'>
                            <div className='card'>
                                <div className='card-body'>

                                    {/* //* logo and favicon */}
                                    {/* <div className='d-flex align-items-start justify-content-evenly'>
                                        <div className='mb-4'>
                                            <label className='form-label ps-2'>Logo</label>
                                            <div className='d-flex flex-column align-items-center'>
                                                <div className='position-relative mb-2' style={{ width: '100px', height: '100px', overflow: 'hidden', borderRadius: '10px', border: '1px solid #ccc', backgroundColor: '#f9f9f9' }}>
                                                    {logo ? (
                                                        <img src={logo.preview || logo} alt='Logo Preview' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                    ) : (
                                                        <div className='d-flex justify-content-center align-items-center h-100'>No Logo</div>
                                                    )}
                                                </div>
                                                <button className='btn btn-success mt-2' onClick={() => document.getElementById('logo-input').click()}>Upload Logo</button>
                                                <input type='file' id='logo-input' accept='image/*' onChange={handleLogoChange} style={{ display: 'none' }} />
                                            </div>
                                        </div>

                                        <div className='mb-4'>
                                            <label className='form-label ps-3'>Favicon</label>
                                            <div className='d-flex flex-column align-items-center'>
                                                <div className='position-relative mb-2' style={{ width: '100px', height: '100px', overflow: 'hidden', borderRadius: '10px', border: '1px solid #ccc', backgroundColor: '#f9f9f9' }}>
                                                    {favicon ? (
                                                        <img src={favicon.preview || favicon} alt='Favicon Preview' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                    ) : (
                                                        <div className='d-flex justify-content-center align-items-center h-100'>No Favicon</div>
                                                    )}
                                                </div>
                                                <button className='btn btn-success mt-2' onClick={() => document.getElementById('favicon-input').click()}>Upload Favicon</button>
                                                <input type='file' id='favicon-input' accept='image/*' onChange={handleFaviconChange} style={{ display: 'none' }} />
                                            </div>
                                        </div>
                                    </div> */}

                                    {/* //* header button text */}
                                    <div className='mb-3'>
                                        <label>Header Button Text</label>
                                        <input
                                            type='text'
                                            className='form-control m-0'
                                            placeholder='Enter header button text'
                                            value={headerButtonText}
                                            onChange={handleHeaderTextChange}
                                        />
                                    </div>

                                    {/* //* footer description */}
                                    <div className='mb-3'>
                                        <label>Footer Description</label>
                                        <textarea
                                            className='form-control m-0'
                                            placeholder='Enter footer description'
                                            value={footerDescription}
                                            onChange={handleFooterDescChange}
                                        />
                                    </div>

                                    {/* //* copyright */}
                                    <div className='mb-3'>
                                        <label>Copyright</label>
                                        <input
                                            type='text'
                                            className='form-control m-0'
                                            placeholder='Enter copyright text'
                                            value={copyright}
                                            onChange={handleCopyrightChange}
                                        />
                                    </div>

                                    {/* //* update */}
                                    <div className='d-flex justify-content-end'>
                                        <button className='btn btn-primary' onClick={executeUpdateVendorApi} disabled={disableButton}>
                                            {!loading ? 'Update' : <Loader />}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SiteSetting;
